<section class="hp" aria-label="Elige tu premio y entra al recorrido">
	<div class="hp-titulo-movil">
		<span class="hp-titulo__kicker">Sorteo Anáhuac · 11ª edición</span>
		<h2>Elige tu premio y entra</h2>
		<p>Toca un inmueble para encenderlo y vuelve a tocarlo para recorrerlo</p>
	</div>
	<div class="hp-scroll" #scroll>
		<div class="hp-escena" [class.hp-escena--entrando]="entrando" [class.hp-escena--saliendo]="saliendo"
			[class.hp-escena--foco]="hover || seleccionado" [style.transform-origin]="origen">

			<div class="hp-cielo"></div>
			<div class="hp-estrellas">
				<i *ngFor="let e of estrellas" [style.left.%]="e.x" [style.top.%]="e.y" [style.width.px]="e.t"
					[style.height.px]="e.t" [style.animation-delay.s]="e.d"></i>
			</div>
			<div class="hp-sol"></div>
			<div class="hp-nube hp-nube--1"></div>
			<div class="hp-nube hp-nube--2"></div>
			<div class="hp-nube hp-nube--3"></div>

			<div class="hp-titulo">
				<span class="hp-titulo__kicker">Sorteo Anáhuac · 11ª edición</span>
				<h2>Elige tu premio y entra</h2>
				<p>Pasa el cursor sobre cada inmueble para encenderlo y haz clic para recorrerlo por dentro</p>
			</div>

			<div class="hp-suelo">
				<div class="hp-banqueta"></div>
				<div class="hp-calle"><span class="hp-linea"></span></div>
			</div>
			<span class="hp-farol" *ngFor="let f of faroles" [style.left.%]="f"></span>

			<button type="button" *ngFor="let p of premios" class="hp-premio hp-premio--{{ p.id }}"
				[class.hp-premio--activo]="hover === p || seleccionado === p"
				[style.left.%]="p.left" [style.bottom.%]="p.bottom" [style.width.%]="p.width"
				(mouseenter)="hover = p" (mouseleave)="hover = null" (focus)="hover = p" (blur)="hover = null"
				(click)="tocar(p)"
				[class.hp-premio--pronto]="!p.recorrido"
				[attr.aria-label]="p.lugar + ' premio, ' + p.ciudad + ', valor más de ' + p.valor + ' millones. ' + (p.recorrido ? 'Entrar al recorrido' : 'Recorrido próximamente')">

				<span class="hp-premio__sombra"></span>
				<span class="hp-premio__halo"></span>

				<span class="hp-premio__pieza">
					<!-- cuando diseño entregue el recorte PNG del inmueble, se usa en lugar del SVG -->
					<img *ngIf="p.imagen" [src]="p.imagen" alt="">

					<ng-container *ngIf="!p.imagen" [ngSwitch]="p.id">

						<!-- 1° Edo. México: torre sobre isla verde -->
						<svg *ngSwitchCase="'edomex'" viewBox="0 0 500 620" aria-hidden="true">
							<ellipse cx="250" cy="592" rx="246" ry="26" fill="#22391f" />
							<ellipse cx="250" cy="578" rx="246" ry="32" fill="#4f8a3c" />
							<path d="M40 586 Q170 556 250 574 T470 568" stroke="#d8cdb5" stroke-width="5" fill="none" opacity=".75" />
							<path class="muro" d="M158 78 Q245 46 332 70 L332 552 L158 552 Z" fill="#26404c" />
							<rect *ngFor="let v of ventanasEdomex" class="win" [attr.x]="v.x" [attr.y]="v.y" [attr.width]="v.w"
								[attr.height]="v.h" [style.transition-delay.ms]="v.d" />
							<rect x="158" y="74" width="6" height="478" fill="#e9eef0" />
							<rect x="242" y="64" width="4" height="488" fill="#e9eef0" opacity=".8" />
							<rect x="327" y="70" width="5" height="482" fill="#e9eef0" />
							<path d="M146 82 Q245 34 346 62 L346 74 Q245 48 146 94 Z" fill="#eef2f4" />
							<rect x="168" y="528" width="154" height="26" fill="#d9d2c3" />
							<rect class="win" x="198" y="533" width="94" height="18" style="transition-delay: 0ms" />
							<g>
								<circle cx="70" cy="540" r="38" fill="#3c7533" />
								<circle cx="108" cy="522" r="30" fill="#4a8a3b" />
								<circle cx="38" cy="560" r="24" fill="#2f6229" />
								<circle cx="132" cy="556" r="22" fill="#376e2f" />
								<circle cx="382" cy="536" r="36" fill="#3c7533" />
								<circle cx="424" cy="552" r="30" fill="#4a8a3b" />
								<circle cx="350" cy="558" r="22" fill="#2f6229" />
								<circle cx="462" cy="566" r="20" fill="#376e2f" />
								<circle cx="200" cy="572" r="14" fill="#44803a" />
								<circle cx="300" cy="570" r="16" fill="#44803a" />
							</g>
						</svg>

						<!-- 3° Mérida -->
						<svg *ngSwitchCase="'merida'" viewBox="0 0 300 260" aria-hidden="true">
							<rect x="8" y="238" width="284" height="14" fill="#8f969d" />
							<rect class="muro" x="20" y="118" width="250" height="122" fill="#eef0f2" />
							<rect x="40" y="142" width="150" height="96" fill="#565c63" />
							<rect class="win" x="96" y="144" width="40" height="3" style="transition-delay: 0ms" />
							<rect class="muro" x="40" y="28" width="200" height="92" fill="#f3f4f5" />
							<rect x="150" y="8" width="72" height="62" fill="#c9a27a" />
							<path d="M150 20h72M150 32h72M150 44h72M150 56h72" stroke="#b08a63" stroke-width="2" />
							<rect class="win" x="70" y="42" width="62" height="58" style="transition-delay: 120ms" />
							<line x1="101" y1="42" x2="101" y2="100" stroke="#1f2a33" stroke-width="2" />
							<rect x="40" y="88" width="170" height="14" fill="#9fc3d6" opacity=".35" />
							<rect x="40" y="86" width="170" height="3" fill="#2a2f35" />
							<rect x="30" y="110" width="190" height="9" fill="#e2e4e6" />
							<rect class="win" x="206" y="136" width="42" height="20" style="transition-delay: 260ms" />
							<rect x="214" y="166" width="28" height="72" fill="#8a5a3b" />
							<rect x="270" y="150" width="20" height="90" fill="#e2e4e6" />
							<circle cx="262" cy="232" r="12" fill="#3c7533" />
							<circle cx="282" cy="228" r="10" fill="#4a8a3b" />
							<circle cx="22" cy="232" r="10" fill="#3c7533" />
						</svg>

						<!-- 4° Puebla -->
						<svg *ngSwitchCase="'puebla'" viewBox="0 0 260 300" aria-hidden="true">
							<rect x="6" y="282" width="248" height="12" fill="#8f969d" />
							<rect class="muro" x="20" y="16" width="124" height="268" fill="#f2f3f4" />
							<rect class="muro" x="144" y="84" width="100" height="200" fill="#e8e4dc" />
							<rect x="48" y="96" width="32" height="40" fill="#8a5a3b" />
							<path d="M48 104h32M48 112h32M48 120h32M48 128h32" stroke="#6e452c" stroke-width="2" />
							<rect class="win" x="164" y="108" width="50" height="40" style="transition-delay: 80ms" />
							<line x1="189" y1="108" x2="189" y2="148" stroke="#1f2a33" stroke-width="2" />
							<rect x="10" y="176" width="140" height="8" fill="#e2e4e6" />
							<rect x="28" y="196" width="88" height="88" fill="#d8cdb8" />
							<path d="M28 214h88M28 232h88M28 250h88M28 268h88" stroke="#c4b79e" stroke-width="2" />
							<rect class="win" x="36" y="212" width="40" height="44" style="transition-delay: 220ms" />
							<rect x="88" y="212" width="24" height="72" fill="#8a5a3b" />
							<rect x="208" y="190" width="14" height="94" fill="#2c3238" />
							<rect x="150" y="262" width="50" height="22" rx="8" fill="#3c7533" />
						</svg>

						<!-- 5° Querétaro -->
						<svg *ngSwitchCase="'queretaro'" viewBox="0 0 220 200" aria-hidden="true">
							<rect x="6" y="184" width="208" height="12" fill="#8f969d" />
							<rect class="muro" x="18" y="28" width="112" height="158" fill="#f2f3f4" />
							<rect x="130" y="28" width="78" height="158" fill="#cdbba0" />
							<path d="M130 46h78M130 64h78M130 82h78M130 100h78M130 118h78M130 136h78M130 154h78M130 172h78"
								stroke="#b8a487" stroke-width="2" />
							<rect x="14" y="22" width="198" height="8" fill="#e2e4e6" />
							<rect class="win" x="36" y="50" width="70" height="42" style="transition-delay: 60ms" />
							<line x1="71" y1="50" x2="71" y2="92" stroke="#1f2a33" stroke-width="2" />
							<rect class="win" x="142" y="50" width="54" height="42" style="transition-delay: 180ms" />
							<rect class="win" x="142" y="116" width="54" height="44" style="transition-delay: 300ms" />
							<rect class="win" x="36" y="122" width="38" height="36" style="transition-delay: 420ms" />
							<rect x="84" y="118" width="30" height="68" fill="#8a5a3b" />
							<path d="M4 186 L13 116 L22 186 Z" fill="#335f2c" />
							<circle cx="60" cy="182" r="9" fill="#3c7533" />
							<circle cx="126" cy="184" r="8" fill="#4a8a3b" />
						</svg>

						<!-- 2° Cancún: dos torres con palmeras -->
						<svg *ngSwitchCase="'cancun'" viewBox="0 0 420 560" aria-hidden="true">
							<rect x="60" y="528" width="330" height="18" fill="#d9d2c3" />
							<rect class="muro" x="272" y="140" width="96" height="392" fill="#e2e6ea" />
							<rect *ngFor="let v of ventanasCancun2" class="win" [attr.x]="v.x" [attr.y]="v.y" [attr.width]="v.w"
								[attr.height]="v.h" [style.transition-delay.ms]="v.d" />
							<rect class="muro" x="96" y="56" width="180" height="476" fill="#f1f2f3" />
							<rect *ngFor="let v of ventanasCancun" class="win" [attr.x]="v.x" [attr.y]="v.y" [attr.width]="v.w"
								[attr.height]="v.h" [style.transition-delay.ms]="v.d" />
							<rect x="260" y="56" width="16" height="476" fill="#d9a56a" />
							<rect *ngFor="let l of losasCancun" x="92" [attr.y]="l" width="188" height="4" fill="#ffffff" />
							<rect x="90" y="46" width="192" height="12" fill="#e9ecee" />
							<rect x="110" y="500" width="150" height="30" fill="#c8d6dd" />
							<path d="M40 544 Q28 474 52 402" stroke="#7a5a3a" stroke-width="7" fill="none" />
							<path d="M386 544 Q396 480 372 410" stroke="#7a5a3a" stroke-width="7" fill="none" />
							<g fill="#2f6b34" transform="translate(52 402)">
								<path d="M0 0 Q-30 -18 -58 -2 Q-30 -10 0 4Z" />
								<path d="M0 0 Q30 -20 60 -4 Q30 -10 0 4Z" />
								<path d="M0 0 Q-12 -34 -36 -46 Q-10 -30 2 2Z" />
								<path d="M0 0 Q14 -36 40 -44 Q12 -28 -2 2Z" />
								<path d="M0 0 Q-28 4 -46 28 Q-24 10 2 4Z" />
								<path d="M0 0 Q28 6 44 30 Q22 12 -2 4Z" />
							</g>
							<g fill="#2f6b34" transform="translate(372 410)">
								<path d="M0 0 Q-30 -18 -58 -2 Q-30 -10 0 4Z" />
								<path d="M0 0 Q30 -20 60 -4 Q30 -10 0 4Z" />
								<path d="M0 0 Q-12 -34 -36 -46 Q-10 -30 2 2Z" />
								<path d="M0 0 Q14 -36 40 -44 Q12 -28 -2 2Z" />
								<path d="M0 0 Q-28 4 -46 28 Q-24 10 2 4Z" />
								<path d="M0 0 Q28 6 44 30 Q22 12 -2 4Z" />
							</g>
						</svg>
					</ng-container>
				</span>

				<span class="hp-premio__num">{{ p.lugar }}</span>

				<span class="hp-ficha hp-ficha--{{ p.lado }}">
					<span class="hp-ficha__lugar">{{ p.lugar }} Premio</span>
					<strong class="hp-ficha__ciudad">{{ p.ciudad }}</strong>
					<span class="hp-ficha__tipo">{{ p.tipo }} · {{ p.desarrollo }}</span>
					<span class="hp-ficha__valor">Valor + de {{ p.valor }} millones</span>
					<span class="hp-ficha__cta">{{ !p.recorrido ? 'Recorrido próximamente' : (esTactil && seleccionado === p ? 'Toca de nuevo para entrar' : 'Clic para entrar') + ' →' }}</span>
				</span>
			</button>
		</div>
	</div>
	<p class="hp-desliza">Desliza para ver todos los premios →</p>
	<p class="hp-legal">Imágenes ilustrativas</p>
</section>

<!-- ===================== ADENTRO DE LA CASA (sin salir del home) ===================== -->
<div class="ht" *ngIf="abierto" role="dialog" aria-modal="true" [attr.aria-label]="'Recorrido virtual ' + abierto.ciudad">

	<!-- fotos 360 (casa.json + Visor360, igual que /home-piloto) -->
	<ng-container *ngIf="abierto.recorrido === 'fotos'">
		<div class="ht-lienzo" #lienzoTour></div>
		<div class="ht-cargando" *ngIf="!tourListo"><span></span></div>

		<svg class="ht-plano" viewBox="0 0 100 108" aria-hidden="true" *ngIf="casa">
			<line *ngFor="let l of lineas" [attr.x1]="l[0]" [attr.y1]="l[1]" [attr.x2]="l[2]" [attr.y2]="l[3]" />
			<g *ngFor="let p of puntosPlano" class="ht-plano__punto" [class.on]="punto?.id === p.id" (click)="ir(p)">
				<circle [attr.cx]="p.plano![0]" [attr.cy]="p.plano![1]" r="5" />
			</g>
		</svg>

		<div class="ht-pista" *ngIf="pista && tourListo">
			<strong>Arrastra para mirar alrededor</strong>
			<span>Haz clic en los círculos del piso para caminar</span>
		</div>

		<nav class="ht-tira" *ngIf="casa">
			<button type="button" *ngFor="let p of casa.puntos" [class.on]="punto?.id === p.id" (click)="ir(p)">
				<span [style.background-image]="'url(' + carpeta + p.foto + ')'"></span>
				{{ p.titulo }}
			</button>
		</nav>
	</ng-container>

	<!-- casa escaneada en Matterport (igual que /home-piloto-2) -->
	<ng-container *ngIf="abierto.recorrido === 'matterport'">
		<iframe class="ht-iframe" [src]="urlMatterport" title="Recorrido 3D de la casa"
			allow="autoplay; fullscreen; web-share; xr-spatial-tracking" allowfullscreen></iframe>
	</ng-container>

	<header class="ht-barra">
		<div>
			<strong>{{ abierto.lugar }} Premio · {{ abierto.ciudad }}</strong>
			<span *ngIf="punto && abierto.recorrido === 'fotos'">{{ punto.titulo }}</span>
		</div>
		<button type="button" class="ht-cerrar" (click)="cerrar()" aria-label="Salir del recorrido">✕</button>
	</header>

	<a class="ht-compra" [href]="urlCompra" target="_blank" rel="noopener">Compra tu boleto</a>
</div>
